// src/services/produtos/NCMService.js
import { fetchData } from '../Api';

export const buscarNCMs = () => fetchData('/NCM');

export const buscarNcmPorCodigo = (codigo) => fetchData('/NCM/GetByCodigo', { codigo });
